<template>
  <v-dialog
    :persistent="data.persistent"
    v-model="data.useDialog"
    :width="data.getWidth"
  >
    <div class="dialogCon" :class="{'closeBox':data.closeBox}">
      <div class="layerClose" v-if="data.closeBox">
      <v-btn flat icon @click="closePopup()">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
      <div v-html="data.messageHTML"></div>
      <div class="btn">
        <div v-if="data.getBtnCount === 2">
          <v-btn outline round large class="UXbtn" @click="data.getLeftBtnEvent();closePopup();">{{ data.getLeftBtnName }}</v-btn>
          <v-btn round dark large color="#ff8c8c" class="UXbtn" v-if="!data.isLoading && data.getBtnName" @click="data.getButtonEvent();closePopup();">{{ data.getBtnName }}</v-btn>
          <v-btn :loading="data.dialog" round dark large color="#ff8c8c" class="UXbtn" v-else-if="data.isLoading && data.getBtnName" @click="data.getButtonEvent(); changeLoading();">{{ data.getBtnName }}</v-btn>
        </div>
        <div v-else-if="data.getBtnCount === 3">
          <v-btn outline round large class="UXbtn" @click="closePopup();">キャンセル</v-btn>
          <v-btn outline round large class="UXbtn" @click="data.getLeftBtnEvent();closePopup();">{{ data.getLeftBtnName }}</v-btn>
          <v-btn round dark large color="#ff8c8c" class="UXbtn" v-if="!data.isLoading && data.getBtnName" @click="data.getButtonEvent();closePopup();">{{ data.getBtnName }}</v-btn>
          <v-btn :loading="data.dialog" round dark large color="#ff8c8c" class="UXbtn" v-else-if="data.isLoading && data.getBtnName" @click="data.getButtonEvent(); changeLoading();">{{ data.getBtnName }}</v-btn>
        </div>
        <div v-else>
          <v-btn round dark large color="#ff8c8c" class="UXbtn" @click="data.getButtonEvent();closePopup();">確認</v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import Helpers from '@/util/helpers'

export default {
  name: 'DialogPopup',
  data () {
    return {
      data: {
        useDialog: false,
        persistent: true,
        getWidth: 440,
        messageHTML: '',
        getBtnCount: 1,
        getBtnName: '確認',
        getLeftBtnName: 'キャンセル',
        getButtonEvent: () => {},
        getLeftBtnEvent: () => {},
        isLoading: false,
        dialog: false,
        closeBox: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'loginId'
    ])
  },
  watch: {
    loginId (newVal) {
      if (Helpers.isStringValid(newVal)) {
        this.initialize()
      }
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      const defaultData = () => {
        return {
          useDialog: false,
          persistent: true,
          getWidth: 440,
          messageHTML: '',
          getBtnCount: 1,
          getBtnName: '確認',
          getLeftBtnName: 'キャンセル',
          isLoading: false,
          dialog: false,
          closeBox: false,
          getButtonEvent: () => {},
          getLeftBtnEvent: () => {}
        }
      }
      this.data = defaultData()
      this.$eventBus.$off('DialogPopup')
      this.$eventBus.$on('DialogPopup', (val) => {
        try {
          this.data.useDialog = val.useDialog || defaultData().useDialog
          this.data.persistent = val.persistent || defaultData().persistent
          this.data.getWidth = val.getWidth || defaultData().getWidth
          this.data.messageHTML = val.messageHTML || defaultData().messageHTML
          this.data.getBtnCount = val.getBtnCount || defaultData().getBtnCount
          this.data.getBtnName = val.getBtnName || defaultData().getBtnName
          this.data.getLeftBtnName = val.getLeftBtnName || defaultData().getLeftBtnName
          this.data.isLoading = val.isLoading || defaultData().isLoading
          this.data.closeBox = val.closeBox || defaultData().closeBox
          this.data.getButtonEvent = val.getButtonEvent || defaultData().getButtonEvent
          this.data.getLeftBtnEvent = val.getLeftBtnEvent || defaultData().getLeftBtnEvent
          this.data.dialog = false
        } catch (e) {
          console.log(e)
        }
      })
      this.$eventBus.$on('ClosePopup', (val) => this.closePopup())
    },
    changeLoading () {
      this.data.dialog = true
    },
    closePopup () {
      this.data.useDialog = false
    }
  }
}
</script>

<style lang="scss">
.dialogCon {
  &.closeBox {
    padding: 20px 5px;
  }
  .layerClose {
    position: relative;
    height: 20px;
    bottom: 15px;
    text-align: right;
    .v-btn {
      margin:0;
      color:#919191;
    }
}
}
</style>



// WEBPACK FOOTER //
// src/components/DialogPopup.vue